import axios from "axios";
const qs = require("qs");
import { setToken, setRefreshToken, getShowPreference } from "./tokenCheck";
import store from "../store/index";
import jwt_decode from "jwt-decode";

const coderequest = axios.create({
	baseURL:
		// "https://code.simplifycv.com/" // Development gateway
		// "https://code.simplifymycareer.com/" // Staging gateway
		"https://code.hire3x.com/", // production gateway
});

// "https://pythoncode.simplifymycareer.com/"
// request
coderequest.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = "Bearer " + getToken();
		config.headers["userID"] = "e562e893-3ed8-4073-9576-10373bc3e260";

		return config;
	},
	(error) => {
		// Do something with request error
		return error;
	}
);
//response
coderequest.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		// Do something with request error
		if (
			error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401
		) {
			await refreshAccessToken();
			error.config.headers["Authorization"] = "bearer " + getToken();
			return axios(error.config);
		} else {
			return error.response;
		}
	}
);
const websiteRequest = axios.create({
	// baseURL: "https://api-website.simplifycv.com",
	// baseURL: "https://api-website.simplifymycareer.com"
	baseURL: "https://api-website.hire3x.com",
});

websiteRequest.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = "Bearer " + getToken();
		config.headers["userID"] = getProcessedToken();
		// config.headers["userID"] = "5b935330-0f65-4492-b158-5e3e7b9b8bd4";
		// config.headers["userID"] = "e562e893-3ed8-4073-9576-10373bc3e260";

		return config;
	},
	(error) => {
		// Do something with request error
		return error;
	}
);

// function getProcessedToken() {
//   var decoded = jwt_decode(localStorage.getItem("accessToken"));
//   return decoded.sub;
// }

const request = axios.create({
	baseURL:
		// "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/assessment/", // Developent Gateway
		// "http://api.judge.simplifycv.com/"  // Developent Endpoint

		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/assessment/v2/" // Staging Gateway
		// "https://assesment-api.simplifymycareer.com/"  // Staging Endpoint

		"https://gateway.hire3x.com/assessment/", // Production Gateway
	// "https://assessment-api.hire3x.com/"  // Production Endpoint

	// "http://127.0.0.1:8000/", // Local Server
});
const uploadService = axios.create({
	baseURL: "https://awsmultipart.hire3x.com/",
	// "http://localhost:3000/",
});

const ServiceCandidate = axios.create({
	baseURL:
		// "http://localhost:8000/candidate/", // Development
		// "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/candidate/", // Dev Gateway
		// "https://gateway.simplifymycareer.com/candidate", // Staging
	"https://gateway.hire3x.com/candidate/" // production
});

ServiceCandidate.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = "Bearer " + getToken();

		return config;
	},
	(error) => {
		// Do something with request error
		Promise.reject(error);
	}
);

// request
request.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = "Bearer " + getToken();
		// config.headers["userID"] = getProcessedToken();
		return config;
	},
	(error) => {
		// Do something with request error
		return error;
	}
);
//response
request.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		// Do something with request error
		if (
			error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401
		) {
			await refreshAccessToken();
			error.config.headers["Authorization"] = "bearer " + getToken();
			return axios(error.config);
		} else {
			return error.response;
		}
	}
);

// request
const requestrbac = axios.create({
	baseURL:
		// "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/rbac/access/", // Developent Gateway
		// "http://rbac.simplifycv.com/access/" // Developent Endpoint

		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/rbac/access/"  // Staging Gateway
		// "https://rbac.simplifymycareer.com/access/"  // Staging Endpoint

		"https://gateway.hire3x.com/rbac/access/", // Production Gateway
	// "https://rbac.hire3x.com/access/"  // Production Endpoint

	// "http://127.0.0.1:8000/access/" // Local Server
});

requestrbac.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = "Bearer " + getToken();

		return config;
	},
	(error) => {
		// Do something with request error
		return error;
	}
);

//response
requestrbac.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		// Do something with request error
		if (
			error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401
		) {
			await refreshAccessToken();
			error.config.headers["Authorization"] = "bearer " + getToken();
			return axios(error.config);
		} else {
			return error.response;
		}
	}
);
uploadService.interceptors.request.use(
	(config) => {
		// config.headers["Authorization"] = "Bearer " + getToken();
		config.headers["userID"] = getProcessedToken();
		return config;
	},
	(error) => {
		return error.response;
	}
);

const SysToken = axios.create({
	baseURL:
		// "https://keynode.simplifycv.com/" // Development

		// "https://keynode.simplifymycareer.com/"   // Staging

		"https://keynode.hire3x.com/", // Production
});
const KeycloakAPIs = axios.create({
	// baseURL: "https://keynode.simplifycv.com/", // Development

	// baseURL: "https://keynode.simplifymycareer.com/"  // Staging

	baseURL: "https://keynode.hire3x.com/", // Production
});

const SsoService = axios.create({
	baseURL:
		//  "https://auth.simplifymycareer.com/" // Staging &  Development
		"https://auth.hire3x.com/", // Production
});

// Get token from cookie
const getToken = () => {
	let data = document.cookie.split(";");
	for (let i in data) {
		let cur = data[i].split("=");
		if (cur[0].trim() === "accessToken") {
			return cur[1];
		}
	}
};

const getRefreshToken = () => {
	let data = document.cookie.split(";");
	for (let i in data) {
		let cur = data[i].split("=");
		if (cur[0].trim() === "refreshToken") {
			return cur[1];
		}
	}
};

// Getting new Access token using Refresh token

const getNewAccessToken = async () => {
	let payload = qs.stringify({
		grant_type: "refresh_token",
		client_id: "vue-test-app",
		refresh_token: getRefreshToken(),
	});

	try {
		const response = await axios({
			method: "post",
			// url:
			// "https://auth.simplifymycareer.com/auth/realms/hire3x-dev/protocol/openid-connect/token", // Dev
			// "https://auth.simplifymycareer.com/auth/realms/SimplifyCV/protocol/openid-connect/token", // Staging
			url: "https://auth.hire3x.com/auth/realms/SimplifyCV/protocol/openid-connect/token", // Production
			data: payload,
			headers: {
				"content-type": "application/x-www-form-urlencoded;charset=utf-8",
			},
		});

		setToken(response.data.access_token);
		setRefreshToken(response.data.refresh_token);
		localStorage.setItem("accessToken", response.data.access_token);
		store.commit("userVUEX/SET_TOKEN", response.data.access_token);
	} catch (error) {
		store.dispatch("userVUEX/LogOut");
	}
};

// Refresh Google access token using the backend endpoint
export const refreshGoogleToken = async () => {
	const refreshToken = getRefreshToken();

	try {
		const response = await ServiceCandidate.post("/can/auth/google-refresh/", {
			refresh_token: refreshToken,
		});

		if (response.data.type === "Success") {
			const tokens = response.data.data;
			setToken(tokens.id_token);
			store.commit("userVUEX/SET_TOKEN", tokens.id_token);
			localStorage.setItem("accessToken", tokens.id_token);
			// Note: Google doesn't return a new refresh_token on refresh, so we keep the existing one
		} else {
			store.dispatch("userVUEX/LogOut");
		}
	} catch (error) {
		if (
			axios.isCancel(error) ||
			["ECONNABORTED", "ERR_CANCELED"].includes(error.code)
		) {
			return;
		}
		store.dispatch("userVUEX/LogOut");
	}
};

// Unified function to refresh access token based on login type
export const refreshAccessToken = async () => {
	const loginData = getShowPreference();
	if (loginData && loginData.logged_in === "google") {
		// User logged in via Google - use Google refresh endpoint
		await refreshGoogleToken();
	} else {
		// User logged in via Keycloak - use existing refresh flow
		await getNewAccessToken();
	}
};
// For Device Activity
KeycloakAPIs.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = "Bearer " + getToken();

		config.headers["userID"] = getProcessedToken();

		return config;
	},

	(error) => {
		// Do something with request error

		return error;
	}
);
function getProcessedToken() {
	var decoded = jwt_decode(
		localStorage.getItem("vue_token") || localStorage.getItem("accessToken")
	);
	return decoded.sub;
}

export {
	SysToken,
	SsoService,
	requestrbac,
	request,
	coderequest,
	KeycloakAPIs,
	websiteRequest,
	getNewAccessToken,
	uploadService,
};
